// Formulario para captura de catalogo de cuentas
import React , { useState , useRef , useEffect } from 'react'


import { Row , Col, Container } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faCircleUser, faUser, faXmarkCircle , faFileInvoice } from '@fortawesome/free-solid-svg-icons'
import FormHeader from './FormHeader';

import Form1 from './Form1';
import FormEmail from './FormEmail';



function FormCatalogo( { setClose }) {

    function onClose()
    {
        console.log( "setClose") ; 
        setClose() ;
    }

    function showMore()
    {

    }

  return (
    <Container className='d-flex flex-column align-items-center '  >
    
    <div className=" d-flex flex-column justify-content-center box-1 backemployer-2 mb-5" 
        style={{paddingTop:'31px' , width :'75%' }} > 


        <FormHeader close={onClose}></FormHeader>

        <Form1></Form1>

        <FormEmail></FormEmail>

        <Row>
            <Col className='col-sm-8'>
            </Col>

            <Col className='col-sm-4  text-end'>
                <p onClick={showMore} style={{color:'green' , paddingTop : '5px' , cursor :'pointer' }}><u>Agregar datos Adicionales:</u></p>
            </Col>
        </Row>
    


    </div>


    </Container>
  )
}

export default FormCatalogo